import './e-device.scss';

// import Swiper from 'swiper/bundle';
import { CategorySwitch } from './category-switch';
import { CookieHandler } from '../../utilities/js/cookie-handler';
import Swiper, { Lazy, Navigation } from 'swiper';

class EDevice {
    constructor (element) {
        this.$module = element;
        this.$switcher = null;
        this.$sliders = null;
        this.sliders = [];
        this.$imageSliders = null;
        this.imageSliders = [];
        this.$mains = null;
        this.$subline = null;
        this.cookieHandler = CookieHandler();
        this.categorySwitch = null;
        this.actionHandler = null;
        this.summaryHandler = null;
        if (typeof window.summaryHandler !== 'undefined') {
            this.summaryHandler = window.summaryHandler;
        }
        this.slider = null;
    }

    // this function will make a ajax call and gets the module markup as response
    // after that it will insert the markup
    // meanwhile there will be a spinner
    loadModule (options) {
        const url = this.$module.getAttribute('data-url');
        const request = new XMLHttpRequest();

        request.open('GET', url, true);

        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                const markup = request.response;
                this.$module.innerHTML = markup;
                window.initContent(this.$module);
                this.init();

                // call callback with actionHandler elements to bind actionhandler
                // options.initActionHandler(this.$module.querySelector('[data-e-device="main-wrapper"]'));
            } else {
                console.warn('We reached our target server, but it returned an error');
            }
        };

        request.onerror = () => {
            console.log('There was a connection error of some sort');
        };

        request.send();

        // bind summaryHandler
        // this.summaryHandler = options.summaryHandler;
    }

    init () {
        this.cacheDomElements();
        this.initImageSlider();
        this.initSlider();
        this.bindSlideEvents();

        // define object with some elements for the category switcher
        const elements = {
            $module: this.$module,
            $mains: this.$mains
        };
        this.categorySwitch = new CategorySwitch(elements);
        this.categorySwitch.init();

        // update slider on bp change
        this.bindModuleEvents();
    }

    // get dom elements, because they come later
    cacheDomElements () {
        this.$sliders = this.$module.querySelectorAll('[data-e-device="slider"]');
        this.$imageSliders = this.$module.querySelectorAll('[data-e-device="image-slider"]');
        this.$mains = this.$module.querySelectorAll('[data-e-device="main"]');
        this.$subline = this.$module.querySelector('[data-e-device="subline"]');
    }

    initSlider () {
        let slider;
        const addEvent = (slider, index) => {
            slider.on('slideChangeTransitionStart', () => {
                const activeSlideIndex = this.activeIndex;
                this.imageSliders[index].slideTo(activeSlideIndex, 800);
            });

            slider.on('slideChange', () => {
                this.checkExclusivity();
            });
        };

        for (let i = 0; i < this.$sliders.length; i++) {
            const $slider = this.$sliders[i];
            const $prevArrow = $slider.querySelector('[data-e-device="main-prev"]');
            const $nextArrow = $slider.querySelector('[data-e-device="main-next"]');

            const options = {
                modules: [Lazy, Navigation],
                autoHeight: true,
                slidesPerView: 1,
                centeredSlides: true,
                speed: 300,
                resistance: true,
                resistanceRatio: 0,
                navigation: {
                    prevEl: $prevArrow,
                    nextEl: $nextArrow
                },
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 3
                },
                breakpoints: {
                    // when window width is <= 1023px
                    1023: {
                        autoHeight: false,
                        slidesPerView: 'auto',
                        centeredSlides: true
                    }
                }
            };

            const desktopOptions = {
                modules: [Lazy, Navigation],
                autoHeight: true,
                slidesPerView: 1,
                centeredSlides: true,
                speed: 300,
                resistance: true,
                resistanceRatio: 0,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    prevEl: $prevArrow,
                    nextEl: $nextArrow
                },
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 3
                },
                breakpoints: {
                    // when window width is <= 1023px
                    1023: {
                        autoHeight: false,
                        slidesPerView: 'auto',
                        centeredSlides: true
                    }
                }
            };

            // if viewport is bigger than mobile, add fade effect
            if (window.innerWidth >= window.OPTIONS.breakpoints.l) {
                slider = new Swiper($slider, desktopOptions);
            } else {
                slider = new Swiper($slider, options);
            }

            this.sliders.push(slider);

            // hide arrow, when only one slide available
            if (slider.slides.length <= 1) {
                $prevArrow.classList.add('hidden');
                $nextArrow.classList.add('hidden');
            }

            addEvent(slider, i);
        }
    }

    destroySlider () {
        for (let i = 0; i < this.sliders.length; i++) {
            const slider = this.sliders[i];
            slider.destroy(true, true);
        }
        this.sliders.length = 0;
    }

    reInitSlider () {
        this.destroySlider();
        this.initSlider();
        setTimeout(() => {
            for (let i = 0; i < this.sliders.length; i++) {
                const slider = this.sliders[i];
                slider.update();
            }
        }, 500);
    }

    bindSlideEvents () {
        const $favButtons = this.$module.querySelectorAll('[data-e-device="favorite"]');
        const $selectButtons = this.$module.querySelectorAll('[data-e-device="select"]');
        const $moreButtons = this.$module.querySelectorAll('[data-e-device="more"]');

        const addFavoriteEvent = ($element) => {
            $element.addEventListener('click', () => {
                if ($element.classList.contains('is--active')) {
                    this.like();
                } else {
                    this.unlike();
                }
            });
        };

        for (let i = 0; i < $favButtons.length; i++) {
            const $favButton = $favButtons[i];
            addFavoriteEvent($favButton, this.like);
        }

        const addSelectEvent = ($element) => {
            $element.addEventListener('click', (e) => {
                e.preventDefault();

                if ($element.classList.contains('is--active')) {
                    this.dropSelection($element);
                } else {
                    this.makeSelection($element);
                }
            });
        };

        for (let j = 0; j < $selectButtons.length; j++) {
            const $selectButton = $selectButtons[j];
            addSelectEvent($selectButton);
        }

        const addCreateOverlayEvent = ($element) => {
            $element.addEventListener('click', (e) => {
                e.preventDefault();
                this.createOverlay();
            });
        };

        for (let k = 0; k < $moreButtons.length; k++) {
            const $moreButton = $moreButtons[k];
            addCreateOverlayEvent($moreButton);
        }
    }

    bindModuleEvents () {
        // events in bp change - re init slider to reset position etc
        document.addEventListener('design_s', () => {
            this.reInitSlider();
        });
        document.addEventListener('design_m', () => {
            this.reInitSlider();
        });
        document.addEventListener('design_l', () => {
            this.reInitSlider();
        });

        // close overlay icon
        const $overlayClose = this.$module.querySelectorAll('[data-e-device="overlay-close"]');

        const addCloseEvent = ($button) => {
            $button.addEventListener('click', () => {
                this.closeOverlay();
            });
        };

        for (let i = 0; i < $overlayClose.length; i++) {
            const $button = $overlayClose[i];
            addCloseEvent($button);
        }
        // end overlay close

        this.$module.addEventListener('categoryChange', () => {
            this.checkExclusivity();
        });
    }

    initImageSlider () {
        for (let i = 0; i < this.$imageSliders.length; i++) {
            const $slider = this.$imageSliders[i];
            const slider = new Swiper($slider, {
                slidesPerView: 1,
                centeredSlides: true,
                speed: 800,
                allowTouchMove: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                    speed: 800
                },
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 2
                }
            });

            this.imageSliders.push(slider);
        }
    }

    like () {
        console.log('i like');
        // what happens
        // es wird im ideen buch gespeichert
    }

    unlike () {
        console.log('i unlike');
        // what happens
        // es wird im ideen buch gespeichert
    }

    makeSelection ($button) {
        // only update price, when exclusive article
        if ($button.getAttribute('data-exclusive') !== null) {
            const price = $button.getAttribute('data-price');
            const product = $button.getAttribute('data-name');
            this.summaryHandler.addPrice(product, price);
        }
        if (this.summaryHandler !== null) {
            this.summaryHandler.addEDevice($button);
        }
        this.setDeviceCookie($button);
    }

    dropSelection ($button) {
        // only update price, when exclusive article
        if ($button.getAttribute('data-exclusive') !== null) {
            const product = $button.getAttribute('data-name');
            this.summaryHandler.removePrice(product);
        }
        // deselect device will remove it from the summary
        if (this.summaryHandler !== null) {
            this.summaryHandler.removeEDevice($button);
        }
    }

    setDeviceCookie ($button) {
        const deviceType = $button.getAttribute('data-type');
        const deviceName = $button.getAttribute('data-name');
        this.cookieHandler.setCookie(deviceType, deviceName);
    }

    resetDeviceCookie ($button) {
        // how to???
    }

    createOverlay () {
        this.$module.classList.add('e-device--overlay');

        setTimeout(() => {
            for (let i = 0; i < this.sliders.length; i++) {
                this.sliders[i].update();
            }
        }, 100);
    }

    closeOverlay () {
        this.$module.classList.remove('e-device--overlay');

        for (let i = 0; i < this.sliders.length; i++) {
            this.sliders[i].update();
        }
    }

    checkExclusivity () {
        // get current active slide from sliderlist
        const $activeSlide = this.$module.querySelector('.e-device__main--active .swiper-slide-active');
        const exclusivityText = $activeSlide.querySelector('[data-exclusive-text]').getAttribute('data-exclusive-text');

        this.$subline.textContent = exclusivityText;
    }
}

export { EDevice };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$eDevice = $context.querySelectorAll('[data-e-device="module"]');
        for (let i = 0; i < $$eDevice.length; i++) {
            const $eDevice = new EDevice($$eDevice[i]);
            $eDevice.loadModule();
        }
    }
});
